// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_ConsultQuote"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: { type: "text" },
      thStyle: { width: "60px" }
    },
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true },
    {
      key: "QuotationTaskNums",
      label: "报价申请单号",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "CustNames",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaIds",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: 'Description', label: '描述', sortable: true,
      thStyle: { width: "10rem" }
    },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
    { key: "is_valid", label: "启用", type: "boolean" },
    { key: "is_send_email", label: "已发邮件", type: "boolean" },
  ],
  detail: [
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px", display: "none" } },
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "80px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: "dataAreaId", label: "销售公司", sortable: true },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "16rem" } },
    { key: "TEC_SpecType", label: "规格型号", sortable: true, thStyle: { width: "10rem" } },
    { key: "quotationType", label: "报价类型", sortable: true, thStyle: { width: "6rem" }, width: "8rem" },
    // { key: "CostGroupId", label: "成本组", sortable: true, thStyle: { width: "6rem" } },
    { key: "DW_ItemGroupId", label: "物料组", sortable: true, thStyle: { width: "6rem" } },
    { key: 'FromQty', label: '起始数量', sortable: true, editable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'ToQty', label: '结束数量', sortable: true, editable: true, type: "number", thStyle: { width: "120px" } },
    { key: "CurrencyCode", label: "币种", editable: true, thStyle: { width: "12rem" } },
    {
      key: 'DeliveryAddress', label: '交货地址', editable: true, sortable: true, type: "textarea",
      width: "150px", thStyle: { width: "14rem" }
    },
    {
      key: 'DeliveryMode', label: '运输方式', editable: true, sortable: true, type: "textarea",
      width: "150px", thStyle: { width: "14rem" }
    },
    {
      key: 'TradeMode', label: '贸易方式', editable: true, sortable: true,
      width: "150px", thStyle: { width: "10rem" }
    },
    { key: 'DemandDate', label: '预计需求日期', sortable: true, type: "date" },
    { key: 'DayDemandQty', label: '日需求量', sortable: true, type: "just_number" },
    {
      key: 'Description', label: '描述', editable: true, sortable: true, type: "textarea",
      width: "150px", thStyle: { width: "14rem" }
    },
    {
      key: 'UnfoldSize', label: '展开尺寸', sortable: true, type: "textarea",
      width: "120px", thStyle: { width: "10rem" }
    },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    { key: "is_send_email", label: "已发邮件", type: "boolean" },

  ],
  application: [
    // { key: 'id', label: '编号', sortable: true, thStyle: { width: "80px" } },
    { key: 'ConsultQuoteApplyNum', label: '询价申请编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "80px" } },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "14rem" } },
    { key: "TEC_SpecType", label: "规格型号", sortable: true, thStyle: { width: "10rem" } },
    // { key: "CostGroupId", label: "成本组", sortable: true, thStyle: { width: "6rem" } },
    { key: "DW_ItemGroupId", label: "物料组", sortable: true, thStyle: { width: "6rem" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "130px" } },
    { key: "quotationType", label: "报价类型", sortable: true, thStyle: { width: "6rem" }, width: "8rem" },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    { key: 'CustName', label: '客户名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    { key: "CompanyName", label: "销售公司名称", sortable: true, thStyle: { width: "8rem" }, width: "8rem", type: "short" },
    { key: 'FromBatchQty', label: '开始数量', sortable: true, editable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'BatchQty', label: '结束数量', sortable: true, editable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true, editable: true, type: "textarea", width: "150px", thStyle: { width: "14rem" } },
    { key: 'DeliveryMode', label: '运输方式', sortable: true, editable: true, type: "textarea", width: "150px", thStyle: { width: "14rem" } },
    { key: 'PurchUser', label: '采购员', sortable: true, _not_to_api: true },
    { key: 'Description', label: '描述', sortable: true, editable: true, type: "textarea", width: "150px", thStyle: { width: "14rem" } },
    { key: 'UnfoldSize', label: '展开尺寸', sortable: true, editable: true, type: "textarea", width: "150px", thStyle: { width: "10rem" } },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    { key: "hasConsultOrder", label: "有询价", type: "boolean" },
    {
      key: "create_by_username", label: "创建人", sortable: true,
      width: '14rem',
      thStyle: { width: "14rem" },
      _not_to_api: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },

    { key: "create_at", label: "创建时间", sortable: true, type: "datetime" },
    { key: "is_valid", label: "启用", type: "boolean" },
  ],
  inventTable_fields: [
    { key: "ItemId", label: "物料编号", sortable: true },
    { key: "NameAlias", label: "物料名称", sortable: true, thStyle: { width: "14rem" } },
    // { key: "Height", label: "长度", sortable: true, type: "number" },
    // { key: "Width", label: "宽度", sortable: true, type: "number" },
    // { key: "Depth", label: "高度", sortable: true, type: "number" },
    { key: "TEC_SpecType", label: "规格型号", sortable: true },
    { key: "CostGroupId", label: "成本组", sortable: true },
    { key: "DW_ItemGroupId", label: "物料组", sortable: true },
    // { key: "TEC_NetArea", label: "净面积", sortable: true, type: "number" },
    { key: "TEC_Weight", label: "单位重量", sortable: true, type: "number" },
    { key: "DW_InventUnitId", label: "单位", sortable: true },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    { key: 'CustName', label: '客户名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    { key: "CompanyName", label: "销售公司名称", sortable: true, thStyle: { width: "8rem" }, width: "8rem", type: "short" },
    { key: 'BatchQty', label: '报价申请数量', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true },
    { key: 'DeliveryMode', label: '运输方式', sortable: true }
  ],
  consult_vend_fields: [
    { key: 'AccountNum', label: '供应商编号', thStyle: { width: "6rem" } },
    { key: 'SEI_Name', label: '供应商名称', thStyle: { width: "12rem" }, type: "short" },
    { key: 'Currency', label: '币种', thStyle: { width: "6rem" } },
    { key: 'TaxGroup', label: '税组', thStyle: { width: "6rem" } },
    { key: 'InclTax', label: '是否包括销售税' },
    { key: 'DistributionRatio', label: '预分配比例(%)', editable: true, type: "just_integer", },
    { key: 'DistributionDes', label: '预分配描述', editable: true, type: "textarea", thStyle: { width: "12rem" } },
    { key: 'Description', label: '描述', editable: true, type: "textarea" },
    { key: "is_approved", label: "审批", type: "boolean", otherkey: "isRefused" },
    { key: 'approved_by_username', label: '审批人', sortable: true },
    { key: 'approved_at', label: '审批时间', type: 'datetime', sortable: true },
    { key: "is_done", label: "关闭", type: "boolean" },
    { key: "is_send_email", label: "已发邮件", type: "boolean" },
  ],
  consult_handle_fields: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'LineNum', label: '询价单明细行号', sortable: true, thStyle: { width: "120px" } },
    { key: 'ConsultQuoteApplyNum', label: '询价申请单号', sortable: true, thStyle: { width: "120px" } },
    { key: 'AccountNum', label: '供应商编号', sortable: true, thStyle: { width: "6rem" } },
    { key: 'AccountName', label: '供应商名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "quotationType", label: "报价类型", sortable: true, type: "short" },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" } },
    { key: "TEC_SpecType", label: "规格型号", sortable: true, thStyle: { width: "10rem" } },
    { key: 'FromQty', label: '起始数量', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'ToQty', label: '结束数量', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true, width: "150px", thStyle: { width: "10rem" } },
    { key: 'DeliveryMode', label: '运输方式', sortable: true, width: "150px", thStyle: { width: "10rem" } },
    { key: 'TradeMode', label: '贸易方式', sortable: true, width: "150px", thStyle: { width: "10rem" } },
    { key: 'DemandDate', label: '预计需求日期', sortable: true, type: "date", thStyle: { width: "12rem" } },
    { key: 'DayDemandQty', label: '日需求量', sortable: true, type: "just_number" },
    { key: 'Description', label: '询价明细描述', sortable: true, width: "150px", thStyle: { width: "12rem" } },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    {
      key: 'VendAccessory',
      label: '供应商附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    { key: 'Price', label: '报价', sortable: true, type: "number", thStyle: { width: "80px" } },
    { key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: "CurrencyCode", label: "币种", },
    { key: 'InclTax', label: '价格是否含税', },
    { key: 'TaxGroup', label: '税组', },
    { key: 'Transport', label: '其他费用', type: "number", thStyle: { width: "80px" } },
    { key: 'TransportDescription', label: '其他费用备注', sortable: true, width: "150px", thStyle: { width: "12rem" } },
    { key: 'DayOutQty', label: '每日产量', type: "number", thStyle: { width: "80px" } },
    { key: 'vend_price_description', label: '响应描述', sortable: true, width: "150px", thStyle: { width: "12rem" } },
    { key: 'UnfoldSize', label: '展开尺寸', sortable: true, width: "120px", thStyle: { width: "10rem" } },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
  ],
  consult_vend_price_return_fields: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'LineNum', label: '询价单明细行号', sortable: true, thStyle: { width: "120px" } },
    { key: 'AccountNum', label: '供应商编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'AccountName', label: '供应商名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'NameAlias', label: '物料名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: 'FromQty', label: '起始数量', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'ToQty', label: '结束数量', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'Price', label: '报价', sortable: true, editable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "number", thStyle: { width: "120px" } },
    { key: "CurrencyCode", label: "币种", thStyle: { width: "80px" } },
    { key: 'InclTax', label: '价格是否含税', },
    { key: 'TaxGroup', label: '税组', thStyle: { width: "80px" } },
    { key: 'Transport', label: '其他费用', editable: true, type: "number", thStyle: { width: "120px" } },
    { key: 'TransportDescription', label: '其他费用备注', editable: true, type: "textarea", sortable: true, thStyle: { width: "12rem" } },
    { key: 'Description', label: '响应描述', editable: true, type: "textarea", thStyle: { width: "12rem" } },
    { key: 'DayOutQty', label: '每日产量', type: "number", editable: true, thStyle: { width: "120px" } },
  ],
  consult_vend_pre_distribution_fields: [
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px", display: "none" } },
    { key: 'ConsultQuoteApplyNum', label: '询价申请编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: "quotationType", label: "报价类型", sortable: true, type: "short" },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "16rem" } },
    { key: "TEC_SpecType", label: "规格型号", sortable: true, thStyle: { width: "12rem" } },
    { key: "DW_ItemGroupId", label: "物料组", sortable: true, thStyle: { width: "6rem" } },
    {
      key: 'ConsultQuoteDescription', label: '询价单描述', editable: true, sortable: true, type: "textarea",
      width: "150px", thStyle: { width: "14rem" }
    },
    { key: "is_send_email", label: "已发邮件", type: "boolean", thStyle: { width: "6rem" } },
  ],
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  //#region 询价申请
  async getDataApply(_params) {
    let apply_biz_data = new biz_data_helper.base_entity_helper("get_consult_apply_order", {}, {})
    let f = _.map(fields.application, "key")
    // f.push("id");

    let result = await apply_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataDetailApply(params) {
    let f = _.map(fields.application, "key")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Application", {}, {})
    let async_accessory_biz_data = new biz_data_helper.base_entity_helper("async_accessory", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        let num_biz_data = new biz_data_helper.base_entity_helper("get_seq", {}, {})
        //获取code
        let _p = {
          type: "CQA",
          date: _date.format(new Date(), "yyyy-MM-dd")
        }
        _actions.push(
          num_biz_data.execAction({
            params: _p,
            fields: ["seq"]
          }).action({
            output_last_item_map: {
              seq: "ConsultQuoteApplyNum"
            }
          })
        )
        _actions.push(
          detail_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({
            mixin_last_item_map: {
              ConsultQuoteApplyNum: "ConsultQuoteApplyNum"
            }
          })
        )
      }
      if (k == "edit" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
        if (params.isUpdateAccessory) {
          _actions.push(
            async_accessory_biz_data.execAction({
              params: _.map(params[k], (t) => { return { TypeCode: "sq", QuotationTaskDetailId: t.QuotationTaskDetailId, Accessory: t.Accessory } }),
              fields: f
            }).action({})
          )
        }
      }

      if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  //#endregion
  //#region 询价单
  async getData(_params) {
    let f = _.map(fields.default, "key")
    f.push("create_by")
    f.push("fcCheckCQIsOk(t.id)")
    f.push("fcCheckCQHandleIsOk(t.id)")
    f.push("fcCheckCQApprovedIsOk(t.id)")
    f.push("fcGetConsultQuoteDetailInfo(t.id)")
    let result = await biz_data.selectAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(params) {
    let f = _.map(fields.default, "key")
    f.push("create_by")
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        let num_biz_data = new biz_data_helper.base_entity_helper("get_seq", {}, {})
        //获取code
        let _p = {
          type: "CQO",
          date: _date.format(new Date(), "yyyy-MM-dd")
        }
        _actions.push(
          num_biz_data.execAction({
            params: _p,
            fields: ["seq"]
          }).action({
            output_last_item_map: {
              seq: "ConsultQuoteNum"
            }
          })
        )
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({
            mixin_last_item_map: {
              ConsultQuoteNum: "ConsultQuoteNum"
            }
          })
        )
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []
      for (var t in params) {
        if (t == "add" && params[t].length > 0)
          rt = result.data.BatchResult.Actions[1].Result.Data[0]
        else if (params[t].length > 0)
          rt = result.data.BatchResult.Actions[0].Result.Data[0]
      }
      return rt
    } else {
      return null
    }
  },
  //获取分配的供应商
  async getDataVend(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Vend", {}, {})
    let f = _.map(fields.consult_vend_fields, "key")
    f.push("id")
    f.push("ConsultQuoteId")
    f.push("approved_by")
    f.push("approved_by_username")
    f.push("isRefused")

    let result = await detail_biz_data.selectAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataVend(params) {
    let vend_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Vend", {}, {})
    let f = _.map(fields.consult_vend_fields, "key")
    f.push("id")
    f.push("ConsultQuoteId")

    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          vend_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          vend_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          vend_biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "approved" && params[k].length > 0) {
        _actions.push(
          vend_biz_data.approveAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = result.data.BatchResult.Actions[0].Result.Data[0]
      return rt
    } else {
      return null
    }
  },
  async getDetailData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Detail", {}, {})
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("ConsultQuoteId")
    f.push("AccessoryJson")

    let result = await detail_biz_data.selectAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDetailDataSql(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_consult_order_detail", {}, {})
    let f = _.map(fields.detail, "key")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  async saveDetailData(params) {
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("ConsultQuoteId")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Detail", {}, {})
    // let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {});
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      if (k == "edit" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      // if (k == "approved" && params[k].length > 0) {
      //   _actions.push(
      //     detail_biz_data.approveAction({
      //       params: params[k],
      //       fields: f
      //     }).action({})
      //   );
      // }
      // if (k == "quote_order_approved" && params[k].length > 0) {
      //   _.each(params[k], (t) => {
      //     let sq_form = {
      //       itemId: t.itemId,
      //       documentType: "SalesQuoteOrder",
      //       approveType: "",
      //       documentCreateByUsername: t.documentCreateByUsername
      //     };
      //     _actions.push(
      //       qto_approve_biz_data.execAction({
      //         params: sq_form,
      //         fields: ["id"]
      //       }).action({})
      //     );
      //   })
      // }
      // if (k == "quote_task" && params[k].clear_state) {
      //   _actions.push(
      //     biz_data.updateAction({
      //       params: _.map(params[k].data, (t) => { return { id: t, SQOrderDescription: null } }),
      //       fields: ["id"]
      //     }).action({})
      //   );
      // }
      if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  //#endregion

  //#region 供应商询价报价
  async getConsultVendPrice(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_consult_vend_price", {}, {})
    let f = _.map(fields.consult_handle_fields, "key")
    f.push("id")
    let result = await detail_biz_data.execAction({
      params: params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //供应商报价综合查询
  async getDataVendQuoteFromConsult(_params) {
    let apply_biz_data = new biz_data_helper.base_entity_helper("get_consult_vend_price", {}, {})

    let result = await apply_biz_data.execAction({
      params: _params,
      fields: []
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataVendQuoteFromConsult(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_ConsultQuote_Vend_Price", {}, {})
    let f = _.map(fields.consult_handle_fields, "key")
    f.push("id")
    let _actions = []
    for (var k in params) {
      if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []
      for (var t in params) {
        if (t == "add")
          rt = result.data.BatchResult.Actions[1].Result.Data[0]
        else
          rt = result.data.BatchResult.Actions[0].Result.Data[0]
      }
      return rt
    } else {
      return null
    }
  },
  //采购保存供应商报价
  async saveVendPriceFromConsult(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("insert_vend_price_from_consult", {}, {})
    let result = await detail_biz_data.execAction({
      params: params,
      fields: []
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
  //#endregion
}
export { biz_data, dataForm, fields, methods, rules }

